// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__XOAwG","link":"styles_link__xIT65","text":"styles_text__AoZt4"};